<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <sarala-table
                    :model="model"
                    :headers="headers"
                    ref="table"
                    :topLeftColumns="4"
                    :searchColumns="8"
                    :applyFilter="applyFilter"
                    :draggableTable="true"
                    @reorder="reorder"
                >
                    <template #create-btn>
                        <div class="pa-3">
                            <v-btn
                                color="indigo"
                                class="white--text"
                                @click="newItem"
                            >
                                {{ $t('medias.form.buttons.create') }}
                            </v-btn>
                        </div>
                    </template>

                    <template #top-bottom>
                        <v-row justify="space-around">
                            <v-col>
                                <v-sheet elevation="1" class="py-4 px-1">
                                    <v-chip-group
                                        multiple
                                        active-class="primary--text"
                                        v-model="filterTags"
                                    >
                                        <v-chip
                                            v-for="tag in allTags"
                                            :key="tag.title"
                                            :value="tag.id"
                                        >
                                            {{ tag.title }}
                                        </v-chip>
                                    </v-chip-group>
                                </v-sheet>
                            </v-col>
                        </v-row>
                    </template>

                    <template #draggable>
                        <v-icon x-small class="grab-icon">
                            mdi-drag-vertical
                        </v-icon>
                    </template>

                    <template #active="{ item }">
                        <template v-if="item.active">
                            <v-icon color="green">mdi-check</v-icon>
                        </template>
                        <template v-else>
                            <v-icon color="red">mdi-close</v-icon>
                        </template>
                    </template>

                    <template #tags="{ item }">
                        {{ item.formattedTags }}
                    </template>

                    <template #action="{ item }">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    large
                                    icon
                                    v-on="on"
                                    :href="item.image_url"
                                    target="_blank"
                                >
                                    <v-icon color="blue-grey">
                                        mdi-download
                                    </v-icon>
                                </v-btn>
                            </template>
                            <span>{{ $t('form.actions.download') }}</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    icon
                                    tile
                                    v-on="on"
                                    @click="editItem(item)"
                                >
                                    <v-icon color="blue-grey" v-on="on"
                                        >mdi-pencil</v-icon
                                    >
                                </v-btn>
                            </template>
                            <span>{{ $t('form.actions.edit') }}</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    icon
                                    tile
                                    v-on="on"
                                    @click="deleteItem(item)"
                                >
                                    <v-icon color="red" v-on="on"
                                        >mdi-close</v-icon
                                    >
                                </v-btn>
                            </template>
                            <span>{{ $t('form.actions.delete') }}</span>
                        </v-tooltip>
                    </template>
                </sarala-table>
            </v-col>
        </v-row>
        <v-dialog v-model="dialog" max-width="1000px">
            <v-form ref="form" v-if="media" @submit.prevent="save">
                <v-card>
                    <card-header
                        :title="$t('medias.form.buttons.create')"
                        :showBackButton="false"
                    ></card-header>

                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col sm="6">
                                    <v-text-field
                                        :label="$t('medias.form.labels.title')"
                                        v-model="media.title"
                                    ></v-text-field>
                                </v-col>
                                <v-col sm="3">
                                    <v-text-field
                                        :label="$t('medias.form.labels.height')"
                                        v-model="media.height"
                                    ></v-text-field>
                                </v-col>
                                <v-col sm="3">
                                    <v-text-field
                                        :label="$t('medias.form.labels.width')"
                                        v-model="media.width"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-textarea
                                        :label="
                                            $t('medias.form.labels.description')
                                        "
                                        v-model="media.description"
                                    ></v-textarea>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-autocomplete
                                        v-model="media.tags"
                                        :items="allTags"
                                        chips
                                        hide-selected
                                        deletable-chips
                                        multiple
                                        counter
                                        item-text="title"
                                        return-object
                                        label="Tags"
                                    >
                                    </v-autocomplete>
                                </v-col>
                                <v-col>
                                    <v-file-input
                                        :label="$t('medias.form.labels.file')"
                                        v-model="media.image"
                                        show-size
                                    ></v-file-input>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-switch
                                        v-model="media.active"
                                        :label="$t('medias.form.labels.active')"
                                    ></v-switch>
                                </v-col>
                            </v-row>
                            <v-row v-if="media.image_url">
                                <v-col>
                                    <v-img
                                        :src="media.image_url"
                                        class="d-flex align-start"
                                    />
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>

                    <form-actions
                        :loadingSave="loading"
                        :showBackButton="false"
                    >
                        <template #middle>
                            <v-btn color="grey" @click="dialog = false" text>
                                {{ $t('medias.form.buttons.close') }}
                            </v-btn>
                        </template>
                    </form-actions>
                </v-card>
            </v-form>
        </v-dialog>
        <confirm ref="confirm_remove" width="500px"></confirm>
    </v-container>
</template>

<script>
import Media from '@/models/Media'
import Tag from '@/models/Tag'
import SaralaTable from '@/shared/components/SaralaTable'
import Confirm from '@/components/dialogs/Confirm'
import CardHeader from '@/components/utils/CardHeader'
import FormActions from '@/components/utils/FormActions'

export default {
    components: {
        'sarala-table': SaralaTable,
        confirm: Confirm,
        'card-header': CardHeader,
        'form-actions': FormActions,
    },

    data: () => {
        return {
            loading: false,
            dialog: false,
            media: null,
            allTags: null,
            filterTags: [],
        }
    },

    watch: {
        filterTags: function() {
            this.$refs.table.getItems()
        },
    },

    computed: {
        model() {
            return new Media()
        },

        headers() {
            return [
                {
                    text: '',
                    value: 'draggable',
                    sortable: false,
                    width: 30,
                },
                {
                    text: this.$t('medias.form.labels.title'),
                    value: 'title',
                    sortable: false,
                },
                {
                    text: this.$t('medias.form.labels.height'),
                    value: 'height',
                    sortable: false,
                },
                {
                    text: this.$t('medias.form.labels.width'),
                    value: 'width',
                    sortable: false,
                },
                {
                    text: this.$t('medias.form.labels.active'),
                    value: 'active',
                    sortable: false,
                },
                {
                    text: 'Tags',
                    value: 'tags',
                    sortable: false,
                },
                {
                    text: this.$t('tables.actions'),
                    value: 'action',
                    width: 150,
                    sortable: false,
                    align: 'end',
                },
            ]
        },
    },

    methods: {
        newItem() {
            this.media = new Media()
            this.dialog = true
        },

        editItem(item) {
            this.media = item
            this.dialog = true
        },

        async deleteItem(item) {
            let confirm = await this.$refs.confirm_remove.open(
                this.$t('medias.index.messages.delete'),
                this.$t('medias.index.messages.delete-confirmation', {
                    media: item.title,
                }),
            )

            if (!confirm) return

            let clone = item.clone()

            let res = await clone.delete().catch(() => {})

            if (!res) return

            this.$refs.table.getItems()

            this.$bus.$emit(
                'notify',
                'success',
                this.$t('medias.index.messages.delete-success', {
                    media: item.title,
                }),
            )
        },

        async getAllTags(page = 1) {
            let tagModel = new Tag()

            let tags = await tagModel.paginate(50, page).catch(() => {})

            if (!tags) return

            let data = tags.data

            if (tags.meta.pagination.total_pages > page) {
                data.concat(await this.getAllTags(page + 1))
            }

            this.allTags = data
        },

        async save() {
            this.loading = true
            let clone = this.media.clone()

            if (typeof clone.active === 'undefined') {
                clone.active = false
            }

            let res = null

            try {
                res = await clone.save().catch(() => {})
            } finally {
                this.loading = false
            }

            if (!res) return

            this.dialog = false

            this.$bus.$emit(
                'notify',
                'success',
                this.$t('medias.form.bus.save-success', {
                    media: clone.title,
                }),
            )

            this.$refs.table.getItems()
        },

        applyFilter(model) {
            model.where('byTags', this.filterTags)
        },

        async reorder(items) {
            await this.model.reorder(items)
        },
    },

    mounted() {
        this.getAllTags()
    },
}
</script>
